module.exports = __webpack_public_path__ + "img/warning.48c60712.svg";